

import { supabase } from '../client'
import { updateProfile } from './profile'

/* ── SYNC ENTITLEMENT ─────────────────────────────────────────── */

/**
 * Whether the account has booked/activated HappyCloud Sync. Sync is a paid
 * add-on, so being authenticated does NOT imply sync. Stored on `profiles`
 * (see migration 20260626120000). False when there is no profile row.
 *
 * **Throws when the cloud does not answer.** „Keine Antwort“ ist nicht „nicht
 * gebucht“: Über `getProfile` (das jeden Fehler zu `null` macht) wurde ohne Netz
 * „nicht gebucht“ daraus — kein Offline-Symbol, kein Sync, im Web die Konto-Seite
 * für Zahlende (25.10.2026). Der Aufrufer hält dann den bisherigen Stand.
 */
export async function getSyncEntitlement(userId: string): Promise<boolean> {
  if (!supabase) return false

  const { data, error } = await supabase
    .from('profiles')
    .select('sync_entitlement')
    .eq('id', userId)
    .maybeSingle()

  if (error) throw new Error(error.message)
  return data?.sync_entitlement === true
}

/**
 * Activate (or deactivate) HappyCloud Sync for the account.
 *
 * Beta: the client is allowed to self-activate (the profiles UPDATE policy does
 * not protect this column yet). When real billing lands this must move behind a
 * server function / payment webhook — see the migration note.
 */
export async function setSyncEntitlement(userId: string, enabled: boolean): Promise<boolean> {
  return updateProfile(userId, { sync_entitlement: enabled })
}
